import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Formik, Field } from "formik";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Button,
  Tabs,
  Form,
  Input,
  Alert,
  Typography,
  Row,
  Col,
  Select,
  Radio,
  Image,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import * as surveyActions from "../../../../actionCreators/Survey";
import PopupModal from "../../../../Components/PopupModal";
import { fallBackImage } from "../../../../utils/fallbackImage";
import * as dropDownActions from "../../../../actionCreators/DropDown";

import "./style/viewSurvey.css";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

// const localities = ["Karachi", "Lahore", "Sheikhupura"];
// const localityCodes = ["0921", "codeHome", "6753"];
// const wards = ["A", "B", "C"];
// const propertyTypes = ["Commercial", "Agri"];
const sourceOfInformations = ["Owner", "Occupier"];

const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;

const ViewSurvey = ({
  rowData,
  closeViewSurvey,
  inspectorName,
  currentSurvey,
  surveyApproval,
  propertyTypes,
  buildingTypes,
  getBuildingTypes,
  getPropertyTypes,
  getLocalities,
  getLocalityCodes,
  getWards,
  getBlocks,
  localities,
  localityCodes,
  wards,
  blocks,
}) => {
  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [showRejectModal, setShowRejectModal] = React.useState(false);
  const [rejectionNote, setRejectionNote] = React.useState("");
  const [showRejectionTab, setShowRejectionTab] = React.useState(true);
  const [locality, setLocality] = React.useState(rowData.locality);
  const [localityCode, setLocalityCode] = React.useState(rowData.locality_code);
  const [ward, setWard] = React.useState(rowData.ward);
  const [block, setBlock] = React.useState(rowData.block_name);
  const [surveyData, setSurveyData] = React.useState({
    property_use: "",
    location: "",
  });
  const [civicAmentities, setCivicAmentities] = React.useState({
    electricity: "",
    gas: "",
    telephone: "",
    sanitation: "",
    public_transport: "",
    sewerage: "",
    water_supply: "",
    road_condition: "",
  });
  const [floorsDetail, setFloorsDetail] = React.useState({
    basement_use: "",
    first_floor_use: "",
    second_floor_use: "",
    other_floor_use: "",
  });
  const [surveyApprovalData, setSurveyApprovalData] = React.useState({
    approval_status: "",
    submission_type: "",
  });
  const [sruveyImages, setSurveyImages] = React.useState();
  const [propertyType, setPropertyType] = React.useState(rowData.property_type);
  const [buildingType, setBuildingType] = React.useState(rowData.building_type);

  React.useEffect(() => {
    getPropertyTypes();
    getBuildingTypes();
    getLocalities({ circle_id: rowData.circle_id });
  }, []);

  React.useEffect(() => {
    if (localities.data) {
      getLocalityCodes({ locality_id: rowData.locality });
    }
  }, [localities]);

  React.useEffect(() => {
    if (localityCodes.data) {
      getWards({ locality_code_id: rowData.locality_code });
    }
  }, [localityCodes]);

  React.useEffect(() => {
    if (wards.data) {
      getBlocks({ ward_id: rowData.ward });
    }
  }, [wards]);

  React.useEffect(() => {
    if (rowData) {
      setSurveyData((val) => ({
        ...val,
        property_use: rowData.property_use || "",
        location: rowData.location || "",
      }));
      if (rowData.rejection_note) {
        setRejectionNote(rowData.rejection_note || "");
        setShowRejectionTab(false);
      }
      setSurveyApprovalData((val) => ({
        ...val,
        approval_status: rowData.approval_status || "",
        submission_type: rowData.submission_type || "",
      }));
      if (rowData.survey_civic_amentity) {
        setCivicAmentities((val) => ({
          ...val,
          electricity:
            rowData.survey_civic_amentity.electricity !== null
              ? rowData.survey_civic_amentity.electricity
              : "",
          gas:
            rowData.survey_civic_amentity.gas !== null
              ? rowData.survey_civic_amentity.gas
              : "",
          public_transport:
            rowData.survey_civic_amentity.public_transport !== null
              ? rowData.survey_civic_amentity.public_transport
              : "",
          road_condition: rowData.survey_civic_amentity.road_condition || "",
          sanitation:
            rowData.survey_civic_amentity.sanitation !== null
              ? rowData.survey_civic_amentity.sanitation
              : "",
          sewerage:
            rowData.survey_civic_amentity.sewerage !== null
              ? rowData.survey_civic_amentity.sewerage
              : "",
          telephone:
            rowData.survey_civic_amentity.telephone !== null
              ? rowData.survey_civic_amentity.telephone
              : "",
          water_supply:
            rowData.survey_civic_amentity.water_supply !== null
              ? rowData.survey_civic_amentity.water_supply
              : "",
        }));
      }
      if (rowData.survey_building_detail) {
        setFloorsDetail((val) => ({
          ...val,
          basement_use: rowData.survey_building_detail.basement_use || "",
          first_floor_use: rowData.survey_building_detail.first_floor_use || "",
          second_floor_use:
            rowData.survey_building_detail.second_floor_use || "",
          other_floor_use: rowData.survey_building_detail.other_floor_use || "",
        }));
      }
      if (rowData.survey_documents) {
        setSurveyImages(rowData.survey_documents);
      }
    }
  }, [rowData]);

  React.useEffect(() => {
    if (Object.keys(currentSurvey.data).length !== 0) {
      setSurveyApprovalData((val) => ({
        ...val,
        approval_status: currentSurvey.data.approval_status || "",
        submission_type: currentSurvey.data.submission_type || "",
      }));
      if (currentSurvey.data.rejection_note) {
        setRejectionNote(currentSurvey.data.rejection_note);
        setShowRejectionTab(false);
      }
    }
  }, [currentSurvey.data]);

  const handleSurveyDataChange = (key) => (event) => {
    setSurveyData((val) => ({ ...val, [key]: event.target.value }));
  };

  const handleSurveyCivicAmentitesChange = (key) => (event) => {
    setCivicAmentities((val) => ({ ...val, [key]: event.target.value }));
  };

  const handleSubmitForm = async (values, actions) => {};

  const handleFloorStatusChange = (key) => (event) => {
    setFloorsDetail((val) => ({ ...val, [key]: event.target.value }));
  };

  const handleRejectClick = () => {
    const rejectionObject = {
      id: rowData.id,
      approval_status: "rejected",
      rejection_note: rejectionNote,
    };
    surveyApproval(rejectionObject);
  };

  const handleApproveClick = () => {
    const approvalObject = {
      id: rowData.id,
      approval_status: "approved",
    };
    surveyApproval(approvalObject);
  };

  const handlocalityChange = (data) => {
    setLocality(data);
    getLocalityCodes({ locality_id: data });
    setLocalityCode(null);
    setWard(null);
    setBlock(null);
  };

  const handlocalityCodeChange = (data) => {
    setLocalityCode(data);
    getWards({ locality_code_id: data });
    setWard(null);
    setBlock(null);
  };

  const handleWardChange = (data) => {
    setWard(data);
    getBlocks({ ward_id: data });
    setBlock(null);
  };

  const handlePropertyTypeChange = (data) => {
    setPropertyType(data);
  };

  const handleBuildingTypeChange = (data) => {
    setBuildingType(data);
  };

  return (
    <React.Fragment>
      <Row>
        <Col span={12}>
          <Typography className="heading">
            General Survey / <b>{inspectorName}</b>
          </Typography>
        </Col>
        <Col span={12}>
          <div className="top-button-wrap">
            {surveyApprovalData.submission_type === "submitted" ? (
              <div>
                <Button
                  className="reject-button"
                  onClick={() => setShowRejectModal(true)}
                  type="ghost"
                  icon={<CloseOutlined />}
                >
                  REJECT
                </Button>
                <Button
                  className="accept-button"
                  onClick={() => setShowApproveModal(true)}
                  type="default"
                  icon={<CheckOutlined />}
                >
                  APPROVE
                </Button>
              </div>
            ) : surveyApprovalData.approval_status === "rejected" ? (
              <Typography className="rejected-heading">Rejected</Typography>
            ) : surveyApprovalData.approval_status === "approved" ? (
              <Button className="blue-button">
                <PrinterOutlined /> PRINT
              </Button>
            ) : (
              <div />
            )}
          </div>
        </Col>
      </Row>
      <Formik
        initialValues={{
          serial_number: rowData.serial_number || "",
          district: rowData.district || "",
          tehsil: rowData.tehsil || "",
          rating_area: rowData?.rating_area?.name || "",
          circle: rowData?.circle?.name || "",
          locality: rowData.locality || "",
          locality_code: rowData.locality_code || "",
          ward: rowData.ward || "",
          block_number: rowData.block_number || "",
          block_name: rowData.block_name || "",
          property_type: rowData.property_type || "",
          construction_year: rowData.construction_year
            ? moment(rowData.construction_year).format("DD MMMM YYYY")
            : null,
          total_land_area: rowData?.total_land_area || "",
          category: rowData?.survey_tax?.category || "",
          assessing_authority_garv:
            rowData?.survey_tax?.assessing_authority_garv || "",
          previous_garv: rowData?.survey_tax?.previous_garv || "",
          tax_inspector_garv: rowData?.survey_tax?.tax_inspector_garv || "",
          aeto_garv: rowData?.survey_tax?.aeto_garv || "",
          remarks: rowData?.survey_tax?.remarks || "",
          survey_date: rowData.survey_date
            ? moment(rowData.survey_date).format("DD MMMM YYYY")
            : null || "",
          source_of_information: rowData?.source_of_information || "",
          organization: rowData?.survey_building_detail?.organization || "",
          stories: rowData?.survey_building_detail?.stories || "",
          area_covered: rowData?.survey_building_detail?.area_covered || "",
          present_condition:
            rowData?.survey_building_detail?.present_condition || "",
          accomodation_description:
            rowData?.survey_building_detail?.accomodation_description || "",
          basement_area: rowData?.survey_building_detail?.basement_area || "",
          first_floor_area:
            rowData?.survey_building_detail?.first_floor_area || "",
          second_floor_area:
            rowData?.survey_building_detail?.second_floor_area || "",
          other_floor_area:
            rowData?.survey_building_detail?.other_floor_area || "",
          survey_owners: rowData?.survey_owners,
          survey_occupiers: rowData?.survey_occupiers,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={(formikProps) => {
          const { errors, isSubmitting, handleSubmit } = formikProps;

          return (
            <>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.email || errors.password || errors.auth}
                  type="error"
                  showIcon
                  className="column-error"
                />
              )}
              <Form onFinish={handleSubmit}>
                <Tabs defaultActiveKey="basic" className="tab-main">
                  <TabPane tab="BASIC DETAILS" key="basic" className="tab-pane">
                    <Row>
                      <Col span={12} className="column-left">
                        <Typography className="typography-faded">
                          Property Use
                        </Typography>
                        <Radio.Group
                          value={surveyData.property_use}
                          onChange={handleSurveyDataChange("property_use")}
                        >
                          <Radio value={"self"}> Self</Radio>
                          <Radio value={"rented"}>Off Rented</Radio>
                        </Radio.Group>
                      </Col>
                      <Col span={12} className="column-right">
                        <Typography className="typography-faded">
                          Location
                        </Typography>
                        <Radio.Group
                          value={surveyData.location}
                          onChange={handleSurveyDataChange("location")}
                        >
                          <Radio value={"Main Road"}> Main Road</Radio>
                          <Radio value={"Off Road"}>Off Road</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="serial_number"
                          labelText="Serial Number"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="district"
                          labelText="District"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="tehsil"
                          labelText="Tehsil"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="rating_area"
                          labelText="Rating Area"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="circle"
                          labelText="Circle"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          name="locality"
                          labelText="Cluster Name"
                          hideErrorMessage={true}
                          defaultValue={locality}
                          value={locality}
                          onChange={(event) => handlocalityChange(event)}
                        >
                          {localities.data &&
                            localities.data.map((locality) => {
                              return (
                                <Option value={locality.id}>
                                  {locality.name}
                                </Option>
                              );
                            })}
                        </Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          value={localityCode}
                          disabled={localityCodes.data ? false : true}
                          name="locality_code"
                          labelText="Cluster Code"
                          hideErrorMessage={true}
                          onChange={(event) => handlocalityCodeChange(event)}
                        >
                          {" "}
                          {localityCodes.data &&
                            localityCodes.data.map((code) => {
                              return (
                                <Option value={code.id}>{code.name}</Option>
                              );
                            })}
                        </Field>
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          name="ward"
                          value={ward}
                          labelText="Ward"
                          disabled={wards.data ? false : true}
                          hideErrorMessage={true}
                          onChange={(event) => handleWardChange(event)}
                        >
                          {wards.data &&
                            wards.data.map((ward) => {
                              return (
                                <Option value={ward.id}>{ward.name}</Option>
                              );
                            })}
                        </Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="block_number"
                          labelText="Block No"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          value={block}
                          labelText="Block Name"
                          disabled={blocks.data ? false : true}
                          hideErrorMessage={true}
                          onChange={(event) => setBlock(event)}
                        >
                          {blocks.data &&
                            blocks.data.map((block) => {
                              return (
                                <Option value={block.id}>{block.name}</Option>
                              );
                            })}
                        </Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          name="property_type"
                          labelText="Property Type"
                          hideErrorMessage={true}
                          value={propertyType}
                          defaultValue={propertyType}
                          onChange={(event) => handlePropertyTypeChange(event)}
                        >
                          {propertyTypes &&
                            propertyTypes.map((property) => {
                              return (
                                <Option value={property.id}>
                                  {property.name}
                                </Option>
                              );
                            })}
                        </Field>
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="construction_year"
                          labelText="Year of Construction/Reconstruction"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="total_land_area"
                          labelText="Total Area of Land"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="IMAGES" key="images" className="tab-pane">
                    {sruveyImages &&
                      sruveyImages.map((image) => {
                        return (
                          <div className="image-parser">
                            <Image
                              width={200}
                              height={200}
                              className="image"
                              src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                              fallback={fallBackImage}
                            />
                          </div>
                        );
                      })}
                  </TabPane>
                  <TabPane tab="OWNERSHIP" key="owners" className="tab-pane">
                    <Tabs tabPosition="left" className="tab-side">
                      {rowData.survey_owners.map((owner) => (
                        <TabPane tab={owner.name} key={owner.id}>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={owner.name}
                                labelText="Name"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                            <Col span={12} className="column-right">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={owner.cnic}
                                labelText="CNIC"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={owner.father_name}
                                labelText="Father/Husband Name"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                            <Col span={12} className="column-right">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={owner.address}
                                labelText="address"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={owner.ownership_share}
                                labelText="Ownership Share"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          {owner.survey_documents &&
                            owner.survey_documents.map((image) => {
                              return (
                                <div className="image-parser">
                                  <Image
                                    width={200}
                                    height={200}
                                    className="image"
                                    src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                    fallback={fallBackImage}
                                  />
                                </div>
                              );
                            })}
                        </TabPane>
                      ))}
                    </Tabs>
                  </TabPane>
                  <TabPane tab="OCCUPIER" key="occupiers" className="tab-pane">
                    <Tabs tabPosition="left" className="tab-side">
                      {rowData.survey_occupiers.map((occupier) => (
                        <TabPane tab={occupier.name} key={occupier.id}>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={occupier.name}
                                labelText="Name"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                            <Col span={12} className="column-right">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={occupier.cnic}
                                labelText="CNIC"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={occupier.father_name}
                                labelText="Father/Husband Name"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                            <Col span={12} className="column-right">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={occupier.address}
                                labelText="address"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12} className="column-left">
                              <Field
                                InputType={Input}
                                component={FormInputField}
                                value={occupier.ownership_share}
                                labelText="Ownership Share"
                                hideErrorMessage={true}
                                className="text-field"
                              />
                            </Col>
                          </Row>
                          {occupier.survey_documents &&
                            occupier.survey_documents.map((image) => {
                              return (
                                <div className="image-parser">
                                  <Image
                                    width={200}
                                    height={200}
                                    className="image"
                                    src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                    fallback={fallBackImage}
                                  />
                                </div>
                              );
                            })}
                        </TabPane>
                      ))}
                    </Tabs>
                  </TabPane>
                  <TabPane
                    tab="AMENTITIES"
                    key="amentities"
                    className="tab-pane"
                  >
                    <Row>
                      <Col span={12} className="column-left">
                        <Typography className="typography-faded">
                          Electricity
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.electricity}
                          onChange={handleSurveyCivicAmentitesChange(
                            "electricity"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                      <Col span={12} className="column-right">
                        <Typography className="typography-faded">
                          Telephone
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.telephone}
                          onChange={handleSurveyCivicAmentitesChange(
                            "telephone"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Typography className="typography-faded">
                          Sanitation
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.sanitation}
                          onChange={handleSurveyCivicAmentitesChange(
                            "sanitation"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                      <Col span={12} className="column-right">
                        <Typography className="typography-faded">
                          Public Transport
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.public_transport}
                          onChange={handleSurveyCivicAmentitesChange(
                            "public_transport"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Typography className="typography-faded">
                          Gas
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.gas}
                          onChange={handleSurveyCivicAmentitesChange("gas")}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                      <Col span={12} className="column-right">
                        <Typography className="typography-faded">
                          Sewerage
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.sewerage}
                          onChange={handleSurveyCivicAmentitesChange(
                            "sewerage"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Typography className="typography-faded">
                          Water Supply
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.water_supply}
                          onChange={handleSurveyCivicAmentitesChange(
                            "water_supply"
                          )}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Col>
                      <Col span={12} className="column-right">
                        <Typography className="typography-faded">
                          Road Condition
                        </Typography>
                        <Radio.Group
                          value={civicAmentities.road_condition}
                          onChange={handleSurveyCivicAmentitesChange(
                            "road_condition"
                          )}
                        >
                          <Radio value={"kacha"}>{"Kacha"}</Radio>
                          <Radio value={"pakka"}>{"Pakka"}</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="COVERED AREA" key="area" className="tab-pane">
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="stories"
                          labelText="No. of Stories"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="area_covered"
                          labelText="Total Covered Area of Building"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="present_condition"
                          labelText="Condition of Building"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="accomodation_description"
                          labelText="Description of Accomodation"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Typography className="heading">Floors</Typography>
                    <Tabs
                      defaultActiveKey="basement"
                      tabPosition="left"
                      className="tab-side"
                    >
                      <TabPane tab="Basement" key="basement">
                        <Row>
                          <Col span={24}>
                            <Typography className="typography-faded">
                              Self / Rented
                            </Typography>
                            <Radio.Group
                              value={floorsDetail.basement_use}
                              onChange={handleFloorStatusChange("basement_use")}
                            >
                              <Radio value={"self"}> Self</Radio>
                              <Radio value={"rented"}>Rented</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col span={12}>
                            <Field
                              InputType={Input}
                              component={FormInputField}
                              name="basement_area"
                              labelText="Covered Area of Building"
                              hideErrorMessage={true}
                              className="text-field"
                            />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tab="First Floor" key="firstFloor">
                        <Row>
                          <Col span={24}>
                            <Typography className="typography-faded">
                              Self / Rented
                            </Typography>
                            <Radio.Group
                              value={floorsDetail.first_floor_use}
                              onChange={handleFloorStatusChange(
                                "first_floor_use"
                              )}
                            >
                              <Radio value={"self"}> Self</Radio>
                              <Radio value={"rented"}>Rented</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col span={12}>
                            <Field
                              InputType={Input}
                              component={FormInputField}
                              name="first_floor_use"
                              labelText="Covered Area of Building"
                              hideErrorMessage={true}
                              className="text-field"
                            />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tab="Second Floor" key="secondFloor">
                        <Row>
                          <Col span={24}>
                            <Typography className="typography-faded">
                              Self / Rented
                            </Typography>
                            <Radio.Group
                              value={floorsDetail.second_floor_use}
                              onChange={handleFloorStatusChange(
                                "second_floor_use"
                              )}
                            >
                              <Radio value={"self"}> Self</Radio>
                              <Radio value={"rented"}>Rented</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col span={12}>
                            <Field
                              InputType={Input}
                              component={FormInputField}
                              name="second_floor_use"
                              labelText="Covered Area of Building"
                              hideErrorMessage={true}
                              className="text-field"
                            />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tab="Others" key="others">
                        <Row>
                          <Col span={24}>
                            <Typography className="typography-faded">
                              Self / Rented
                            </Typography>
                            <Radio.Group
                              value={floorsDetail.other_floor_use}
                              onChange={handleFloorStatusChange(
                                "other_floor_use"
                              )}
                            >
                              <Radio value={"self"}> Self</Radio>
                              <Radio value={"rented"}>Rented</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col span={12}>
                            <Field
                              InputType={Input}
                              component={FormInputField}
                              name="other_floor_use"
                              labelText="Covered Area of Building"
                              hideErrorMessage={true}
                              className="text-field"
                            />
                          </Col>
                        </Row>
                      </TabPane>
                    </Tabs>
                  </TabPane>
                  <TabPane tab="SITE RENT" key="rent" className="tab-pane">
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Select}
                          component={FormInputField}
                          name="source_of_information"
                          labelText="Source of Information"
                          hideErrorMessage={true}
                          className="circle-select"
                        >
                          {sourceOfInformations.map((type) => {
                            return <Option value={type}>{type}</Option>;
                          })}
                        </Field>
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="organization"
                          labelText="Name of Organization"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane
                    tab="OTHER INFO"
                    key="otherInfo"
                    className="tab-pane"
                  >
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="source_of_information"
                          labelText="Source of Information"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="survey_date"
                          labelText="Survey Date"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="GARV" key="garv" className="tab-pane">
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="category"
                          labelText="Category of Valuation Time Applied"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="previous_garv"
                          labelText="Previous GARV"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="tax_inspector_garv"
                          labelText="GARV proposed by TI"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="aeto_garv"
                          labelText="GARV proposed by AETO"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="assessing_authority_garv"
                          labelText="GARV proposed by Accessing Authority"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="remarks"
                          labelText="Remarks"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  {showRejectionTab || (
                    <TabPane tab="NOTE" key="note" className="tab-pane">
                      <TextArea
                        rows={4}
                        name="rejection-note"
                        labelText="Note"
                        onChange={(e) => setRejectionNote(e.target.value)}
                        value={rejectionNote}
                      />
                    </TabPane>
                  )}
                </Tabs>
                <div className="close-property-section">
                  <Button
                    className="blue-button"
                    type="submit"
                    onClick={closeViewSurvey}
                  >
                    Close
                  </Button>
                </div>
              </Form>
              <PopupModal
                title={"Approve Survey"}
                centered
                visible={showApproveModal}
                onOk={handleApproveClick}
                onCancel={() => setShowApproveModal(false)}
                footer={[
                  <Button
                    key="cancel"
                    type="link"
                    onClick={() => setShowApproveModal(false)}
                  >
                    CANCEL
                  </Button>,
                  <Button
                    key="submit"
                    type="link"
                    onClick={() => {
                      handleApproveClick();
                      setShowApproveModal(false);
                    }}
                  >
                    APPROVE
                  </Button>,
                ]}
              >
                <p>Are you sure you want to approve this property?</p>
              </PopupModal>
              <PopupModal
                title={"Reject Survey"}
                centered
                visible={showRejectModal}
                onOk={handleRejectClick}
                onCancel={() => {
                  setShowRejectModal(false);
                  setRejectionNote("");
                }}
                footer={[
                  <Button
                    key="cancel"
                    type="link"
                    onClick={() => {
                      setShowRejectModal(false);
                      setRejectionNote("");
                    }}
                  >
                    CANCEL
                  </Button>,
                  <Button
                    key="submit"
                    type="link"
                    onClick={() => {
                      handleRejectClick();
                      setShowRejectModal(false);
                    }}
                  >
                    REJECT
                  </Button>,
                ]}
              >
                <TextArea
                  rows={4}
                  name="rejection-note"
                  labelText="Note"
                  onChange={(e) => setRejectionNote(e.target.value)}
                  value={rejectionNote}
                />
              </PopupModal>
            </>
          );
        }}
      />
    </React.Fragment>
  );
};

const mapStateToProps = ({
  survey: { surveys, currentSurvey },
  dropDown: {
    propertyTypes,
    buildingTypes,
    localities,
    localityCodes,
    wards,
    blocks,
  },
}) => ({
  surveys,
  currentSurvey,
  propertyTypes,
  buildingTypes,
  localities,
  localityCodes,
  wards,
  blocks,
});

const mapDispatchToProps = (dispatch) => ({
  surveyApproval: bindActionCreators(surveyActions.surveyApproval, dispatch),
  getBuildingTypes: bindActionCreators(
    dropDownActions.getBuildingTypes,
    dispatch
  ),
  getPropertyTypes: bindActionCreators(
    dropDownActions.getPropertyTypes,
    dispatch
  ),
  getLocalities: bindActionCreators(dropDownActions.getLocalities, dispatch),
  getLocalityCodes: bindActionCreators(
    dropDownActions.getLocalityCodes,
    dispatch
  ),
  getWards: bindActionCreators(dropDownActions.getWards, dispatch),
  getBlocks: bindActionCreators(dropDownActions.getBlocks, dispatch),
});

ViewSurvey.propTypes = {
  rowData: PropTypes.object.isRequired,
  closeViewSurvey: PropTypes.func.isRequired,
  inspectorName: PropTypes.string.isRequired,
  surveyApproval: PropTypes.func.isRequired,
  currentSurvey: PropTypes.object.isRequired,
  getLocalities: PropTypes.func.isRequired,
  getLocalityCodes: PropTypes.func.isRequired,
  getWards: PropTypes.func.isRequired,
  getBlocks: PropTypes.func.isRequired,
  localities: PropTypes.object.isRequired,
  localityCodes: PropTypes.object.isRequired,
  wards: PropTypes.object.isRequired,
  blocks: PropTypes.object.isRequired,
  getPropertyTypes: PropTypes.func.isRequired,
  getBuildingTypes: PropTypes.func.isRequired,
  propertyTypes: PropTypes.object.isRequired,
  buildingTypes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSurvey);
